import { Small } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import Icon from '@/components/Icon'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { color } from '@/shared-styles/styles.css'

type Props = {
  isSuccess: boolean
}

export const PriceBadge: React.FC<Props> = ({ isSuccess }) => {
  const { t } = useTranslation()
  const iconStyle = sprinkles({ marginBottom: 'xs', marginX: 'auto' })

  return (
    <div className={sprinkles({ alignSelf: 'center', textAlign: 'center' })}>
      {isSuccess ? (
      <>
        <Icon.Verified className={cn(iconStyle, color.success500)} />
        <Small>{t('priority:PriceAnalysis_GoodPrice_Tag')}</Small>
      </>  
      ) : (
      <>
        <Icon.Info className={cn(iconStyle, color.greyscale500)} />
       <Small>{t('priority:PriceAnalysis_HighPrice_Tag')}</Small>
      </>
      )}
      
    </div>
  )
}
